module.exports = __webpack_public_path__ + "static/object-2-328778e18b7ab709dbe5573934236ce3.png";